/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";

//
// TODO: Reusable generic-typed Ngrx Component Store to replace this?
//
// Just thinking we could then require a prefix for component values,
// would help organize all of them?
//
// Or maybe they just use signalStore with some reusable bits
// to abstract CRUD local storage
//

export type GraphVisibilityKey =
    | "graph_visible:exception"
    | "graph_visible:forcing"
    | "graph_visible:escrow-for-review"
    | "graph_visible:tracking"
    | "graph_visible:watchlist"
    | "graph_visible:insufficient"
    | "graph_visible:exposure"
    | "graph_visible:deficient-lienholder"
    | "graph_visible:payment-history"
    | "graph_visible:transaction"
    | "graph_visible:action-taken"
    | "graph_visible:notification-log";

@Injectable()
export class SessionService {
    constructor() {
        const s = localStorage.getItem("session");
        this._session = s
            ? new Map<string, any>(JSON.parse(s))
            : new Map<string, any>();
    }

    private _session: Map<string, any>;

    set(key: string, value: any) {
        const t = this._session.set(key, value);
        localStorage.setItem("session", JSON.stringify([...t]));
        return t;
    }

    delete(key) {
        const b = this._session.delete(key);
        localStorage.setItem("session", JSON.stringify([...this._session]));
        return b;
    }

    get(key: string) {
        return this._session.get(key);
    }

    getGraphVisible(key: GraphVisibilityKey): boolean {
        return this.get(key) !== false; // default OPEN when unset
    }

    setGraphVisible(key: GraphVisibilityKey, visible: boolean) {
        this.set(key, visible);
    }
}
